import { Text } from '@chakra-ui/react'

import { DeviceType } from '@/graphql/generated/schemas'

import { ConnectionI } from '../../types/types'

interface TailgatePopoverBodyIProps {
  connection: ConnectionI
}

export const TailgatePopoverBody = ({
  connection,
}: TailgatePopoverBodyIProps) => {
  if (connection?.isTailgateEnabled) {
    return (
      <Text color='#5C6C7A' fontSize='12px' mt={1}>
        <p>&#8226; This device is associated, and tailgating is enabled.</p>
        <p>
          &#8226; In edit mode, click to view or edit the tailgating grid
          configuration.
        </p>
      </Text>
    )
  }
  if (connection?.isTailgateGridConfigured) {
    return (
      <Text color='#5C6C7A' fontSize='12px' mt={1}>
        <p>
          &#8226; This device is associated, and the tailgating grid is
          configured.
        </p>
        <p>
          &#8226; In edit mode, click to view or edit the tailgating grid
          configuration.
        </p>
      </Text>
    )
  }
  if (connection?.deviceType == DeviceType.Alarm && connection?.isConnected) {
    return (
      <Text color='#5C6C7A' fontSize='12px' mt={1}>
        Alarm is associated with a camera
      </Text>
    )
  }
  if (connection?.isConnected) {
    return (
      <Text color='#5C6C7A' fontSize='12px' mt={1}>
        <p>
          &#8226; This device is associated, and tailgating detection is not yet
          enabled.
        </p>
        <p>&#8226; Tailgating detection is pending grid configuration.</p>
        <p>&#8226; In edit mode, click to configure the tailgating grid.</p>
      </Text>
    )
  }
  return (
    <Text color='#5C6C7A' fontSize='12px' mt={1}>
      <p>
        &#8226; This device is within view of the camera but not yet associated.
      </p>
      <p>
        &#8226; Associating devices will automatically attach video clips to
        relevant incidents involving this device.
      </p>
      <p>&#8226; In edit mode, click to associate devices.</p>
    </Text>
  )
}
